<template>
  <div class="approvals content-wrapper content-wrapper--align-start">
    <template v-if="isFetching">
      <h1>Link Building</h1>
      <div class="table-options">
        <div class="placeholder-search"></div>
      </div>
      <div class="placeholder-table">
        <div class="placeholder-table__header"></div>
      </div>
    </template>
    <template v-else>
      <h1>Link Building</h1>
      <div class="table-options">
        <span>Filters:</span>
        <div class="select-container select-container--no-label">
          <select v-model="statusFilter" data-cy="status-filter">
            <option value="">All Statuses</option>
            <option default value="Pending Review">Pending Review</option>
            <option value="Revision Needed">Revision Needed</option>
            <option value="Approved">Approved</option>
            <option value="Exported">Exported</option>
            <option value="Live">Live (discontinued)</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="marketFilter">
            <option value="">All Markets</option>
            <option v-for="market in oldMarketList" v-bind:key="market.id" :value="market.id">{{ market.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="siteFilter">
            <option value="">All Sites</option>
            <option v-for="site in siteList" v-bind:key="site.id" :value="site.id">{{ site.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="monthFilter">
            <option value="-1">All Months</option>
            <option v-for="month in monthList" v-bind:key="month.id" :value="month.id">{{ month.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="freelancerFilter">
            <option value="">All Freelancers</option>
            <option v-for="freelancer in freelancerList" v-bind:key="freelancer.id" :value="freelancer.id">{{ freelancer.content.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="search-container">
          <!-- prettier-ignore -->
          <svg data-v-8cd888b6 xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><path fill="#bcbccb" data-v-8cd888b6 d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
          <input class="input input--search-icon" v-model="searchFilter" placeholder="Search brand, anchor text, title or user" />
        </div>
      </div>
      <div class="table">
        <div class="table__headers">
          <div class="table__header">Sites</div>
          <div @click="sortKey = 'url'" class="table__header">Website</div>
          <div @click="sortKey = 'anchor'" class="table__header">Anchor Text</div>
          <div @click="sortKey = 'language'" class="table__header">Language</div>
          <div @click="sortKey = 'submittedBy'" class="table__header">Submitted By</div>
          <div @click="sortKey = 'submittedAt'" class="table__header">Submit Date</div>
          <div @click="sortKey = 'orderedBy'" class="table__header">Requested By</div>
          <div @click="sortKey = 'status'" class="table__header">Status</div>
          <div class="table__header"></div>
        </div>
        <template v-for="(linkbuilding, index) in filteredContentList">
          <router-link v-bind:key="linkbuilding.id" class="table__row" :to="'/approvals/linkbuilding/' + linkbuilding.id" :data-cy="`linkbuilding-${index}`">
            <div class="table__cell">
              <div class="sites" v-for="site in linkbuilding.siteIds" v-bind:key="site">
                <img :src="require(`@/assets/sites/${site}.svg`)" />
              </div>
            </div>
            <div class="table__cell">{{ linkbuilding.url }}</div>
            <div class="table__cell">{{ linkbuilding.anchortext }}</div>
            <div class="table__cell">{{ linkbuilding.language.name }}</div>
            <div class="table__cell">{{ linkbuilding.submittedBy.name }}</div>
            <div class="table__cell">{{ submitDateFormatted(linkbuilding.submittedAt) }}</div>
            <div class="table__cell">{{ linkbuilding.orderedBy.name }}</div>
            <div class="table__cell">{{ linkbuilding.status }}</div>
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </router-link>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'approvals',
  data() {
    return {
      linkbuildingList: [],
      monthList: [
        { id: 0, name: 'January' },
        { id: 1, name: 'February' },
        { id: 2, name: 'March' },
        { id: 3, name: 'April' },
        { id: 4, name: 'May' },
        { id: 5, name: 'June' },
        { id: 6, name: 'July' },
        { id: 7, name: 'August' },
        { id: 8, name: 'September' },
        { id: 9, name: 'October' },
        { id: 10, name: 'November' },
        { id: 11, name: 'December' },
      ],
      isFetching: true,
      searchFilter: '',
      statusFilter: 'Pending Review',
      marketFilter: '',
      siteFilter: '',
      monthFilter: -1,
      freelancerFilter: '',
      sortKey: 'submittedAt',
      checkedIds: [],
    }
  },
  methods: {
    getLinkBuildingList() {
      const oldMarketList = this.$store.getters['oldMarketList']
      let _this = this
      firebase
        .firestore()
        .collection('users')
        .get()
        .then(function(querySnapshot) {
          let userList = []
          querySnapshot.forEach(function(doc) {
            userList.push({ id: doc.id, name: doc.data().name })
          })
          firebase
            .firestore()
            .collection('linkbuilding')
            .get()
            .then(function(querySnapshot) {
              let data = []
              querySnapshot.forEach(function(doc) {
                let submittedBy = {}
                let reviewedBy = {}
                let orderedBy = {}
                let language = {}
                for (let i = 0; i < userList.length; i++) {
                  if (userList[i].id == doc.data().adminData.submittedBy) {
                    submittedBy = userList[i]
                  }
                  if (userList[i].id == doc.data().adminData.reviewedBy) {
                    reviewedBy = userList[i]
                  }
                  if (userList[i].id == doc.data().userData.orderedById) {
                    orderedBy = userList[i]
                  }
                }
                for (let i = 0; i < oldMarketList.length; i++) {
                  if (oldMarketList[i].id == doc.data().userData.languageId) {
                    language = oldMarketList[i]
                  }
                }
                data.push({
                  id: doc.id,
                  status: doc.data().adminData.status,
                  anchortext: doc.data().userData.anchors[0].text,
                  submittedAt: doc.data().adminData.submittedAt,
                  siteIds: doc.data().userData.siteIds,
                  url: doc.data().userData.url,
                  orderedBy,
                  reviewedBy,
                  submittedBy,
                  language,
                })
              })
              _this.linkbuildingList = data
            })
            .catch(function(error) {
              console.error('Error getting documents: ', error)
              _this.$notify({
                text: 'Failed to get content list',
                type: 'error',
              })
            })
        })
        .catch(function(error) {
          console.error('Error getting users documents: ', error)
        })
        .then(function() {
          _this.isFetching = false
        })
    },
    submitDateFormatted(submitDate) {
      let date = new Date(submitDate)
      return date.toLocaleString('da-DK')
    },
  },
  mounted: function() {
    this.getLinkBuildingList()
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    freelancerList() {
      return this.$store.getters.freelancers
    },
    oldMarketList() {
      return this.$store.getters.oldMarketList
    },
    siteList() {
      return this.$store.getters.siteList
    },
    filteredContentList() {
      let contentMatch = this.linkbuildingList.filter(linkbuilding => {
        return (
          (linkbuilding.anchortext.toLowerCase().includes(this.searchFilter.toLowerCase()) || linkbuilding.submittedBy.name.toLowerCase().includes(this.searchFilter.toLowerCase())) &&
          (this.statusFilter == '' || linkbuilding.status == this.statusFilter) &&
          (this.marketFilter == '' || linkbuilding.language.id == this.marketFilter) &&
          (this.monthFilter == -1 || new Date(linkbuilding.submittedAt).getMonth() == this.monthFilter) &&
          (this.freelancerFilter == '' || linkbuilding.submittedBy.id == this.freelancerFilter) &&
          (this.siteFilter == '' || linkbuilding.siteIds.includes(this.siteFilter))
        )
      })

      // if (this.sortKey === 'type') {
      //   contentMatch.sort((a, b) => (a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1))
      if (this.sortKey === 'url') {
        contentMatch.sort((a, b) => (a.url.toLowerCase() > b.url.toLowerCase() ? 1 : -1))
      } else if (this.sortKey === 'anchortext') {
        contentMatch.sort((a, b) => (a.anchortext.toLowerCase() > b.anchortext.toLowerCase() ? 1 : -1))
      } else if (this.sortKey === 'language') {
        contentMatch.sort((a, b) => (a.language.name.toLowerCase() > b.language.name.toLowerCase() ? 1 : -1))
      } else if (this.sortKey === 'submittedBy') {
        contentMatch.sort((a, b) => (a.submittedBy.name < b.submittedBy.name ? 1 : -1))
      } else if (this.sortKey === 'submittedAt') {
        contentMatch.sort((a, b) => (a.submittedAt < b.submittedAt ? 1 : -1))
      } else if (this.sortKey === 'orderedBy') {
        contentMatch.sort((a, b) => (a.orderedBy.name < b.orderedBy.name ? 1 : -1))
      } else if (this.sortKey === 'status') {
        contentMatch.sort((a, b) => (a.status < b.status ? 1 : -1))
      }

      return contentMatch
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/table.scss';
.table__headers,
.table__row {
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto;
}
.sites {
  display: inline-flex;
  padding: 0;
  height: 100%;
  width: 2rem;
  img {
    max-height: 2rem;
  }
}
.content-wrapper--align-start {
  grid-template-rows: auto;
  align-content: start;
}
.placeholder-search {
  margin-left: auto;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  width: 240px;
  height: 33px;
}
.table-options {
  display: flex;
  align-items: center;
}
.search-container {
  width: 240px;
  margin-left: auto;
  position: relative;
}
.search-container > svg {
  position: absolute;
  transform: translateY(-50%);
  top: 45%;
  left: 0.5rem;
}
.table-options .select-container {
  margin-left: 1rem;
}
</style>
